const HOUR_IN_MINUTES = 60;

export { HOUR_IN_MINUTES };
